import { useEffect, useRef } from "react";
import { pb } from "@/lib/pocketbase";
import type { ProgressData } from "@/services/articleProgress";

export function useArticleProgress(
  postId: string | null,
  onUpdate: (data: ProgressData) => void,
) {
  const unsubscribeRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (!postId) return;

    const subscribe = async () => {
      try {
        const unsubscribe = await pb
          .collection("posts")
          .subscribe(postId, (e) => {
            if (e.action === "update" && e.record.progress) {
              const data =
                typeof e.record.progress === "string"
                  ? JSON.parse(e.record.progress)
                  : e.record.progress;

              onUpdate({
                progress: data.percentage || 0,
                currentStage: data.stage || "research",
                message: data.message || "Processing...",
                isComplete: data.isCompleted || false,
                error: data.hasError ? data.message : undefined,
              });
            }
          });

        unsubscribeRef.current = unsubscribe;
      } catch (error) {
        console.error("Failed to subscribe to article progress:", error);
      }
    };

    subscribe();

    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
        unsubscribeRef.current = null;
      }
    };
  }, [postId, onUpdate]);

  return () => {
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
      unsubscribeRef.current = null;
    }
  };
}
